export enum EFarmAchievments {
  SOCIAL_SHOP = "social_shop",
  HARVEST_FARM = "harvest_farm",
  HARVEST_FIELD = "harvest_field",
  HARVEST_FACTORY = "harvest_factory",
}
